import { createFileRoute } from '@tanstack/react-router';

import { RouteGuard } from '@/components';

export const Route = createFileRoute('/admin/user-management/_auth')({
  component: () => <RouteGuard can="manage" a="UserManagement" />,
});
